import { CommunitiesTypeFilter } from '../feed/CommunitiesTypeFilter';
import { LocationAndZoneFilters } from '../feed/LocationAndZoneFilters';
import { FilterResultsSummary } from '../feed/FilterResultsSummary';
import { MobileDiscoverFilterSheet } from './MobileDiscoverFilterSheet';
import { StickyFilterContainer } from '@/components/ui/sticky-filter-container';
import { useIsMobile } from '@/hooks/use-mobile';

interface Community {
  id: string;
  name: string;
  members_count?: number;
}

interface DiscoverFiltersProps {
  selectedCommunity: string;
  onCommunityChange: (value: string) => void;
  locationFilter: string;
  onLocationFilterChange: (value: string) => void;
  communities: Community[];
  communitiesLoading: boolean;
  filteredCount: number;
  totalCount: number;
  showFilters: boolean;
  onToggleFilters: () => void;
}

export const DiscoverFilters = ({
  selectedCommunity,
  onCommunityChange,
  locationFilter,
  onLocationFilterChange,
  communities,
  communitiesLoading,
  filteredCount,
  totalCount,
  showFilters,
  onToggleFilters
}: DiscoverFiltersProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <StickyFilterContainer maxWidth="md">
        <MobileDiscoverFilterSheet
          selectedCommunity={selectedCommunity}
          onCommunityChange={onCommunityChange}
          locationFilter={locationFilter}
          onLocationFilterChange={onLocationFilterChange}
          communities={communities}
          communitiesLoading={communitiesLoading}
          showFilters={showFilters}
          onToggleFilters={onToggleFilters}
        />

        {showFilters && (
          <FilterResultsSummary 
            postTypeFilter="all"
            selectedCommunity={selectedCommunity}
            locationFilter={locationFilter}
            filteredCount={filteredCount}
            totalCount={totalCount}
          />
        )}
      </StickyFilterContainer>
    );
  }

  if (!showFilters) return null;

  return (
    <StickyFilterContainer maxWidth="md">
      <CommunitiesTypeFilter 
        selectedCommunity={selectedCommunity}
        onCommunityChange={onCommunityChange}
      />

      <LocationAndZoneFilters 
        locationFilter={locationFilter}
        onLocationFilterChange={onLocationFilterChange}
      />

      <FilterResultsSummary 
        postTypeFilter="all"
        selectedCommunity={selectedCommunity}
        locationFilter={locationFilter}
        filteredCount={filteredCount}
        totalCount={totalCount}
      />
    </StickyFilterContainer>
  );
};